/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { animated, useSpring } from "@react-spring/three"
import { useGLTF } from "@react-three/drei"
import { useFrame, useLoader } from "@react-three/fiber"
import React, { useEffect, useRef, useState } from "react"
import { sRGBEncoding } from "three"
import { TextureLoader } from "three/src/loaders/TextureLoader"
import Dust from "./Dust"

export default function Model(props) {
    const group = useRef()
    const gateShaderRef = useRef()
    // const portalRef = useRef()
    const spotLightRef = useRef()
    const spotLight2Ref = useRef()
    const target2Ref = useRef()
    const lightStrobeRef = useRef()
    const ambientLightRef = useRef()
    const targetRef = useRef()
    const monitorShaderRef = useRef()
    const { nodes } = useGLTF("/stargate.glb")
    const [active, setActive] = useState(true)
    const [sirenActive, setSirenActive] = useState(false)
    const [init, setInit] = useState(false)

    const springs = useSpring({
        scale: active ? [0.83, 0.83, 0.83] : [0.83, 0.83, 0],
        visible: active ? true : false,
    })

    useFrame((state, delta) => {
        if (gateShaderRef.current) {
            gateShaderRef.current.uTime += delta
        }
        if (monitorShaderRef.current) {
            monitorShaderRef.current.uTime += delta
        }
        if (targetRef.current) {
            const time = state.clock.getElapsedTime()
            targetRef.current.position.x = spotLightRef.current.position.x + Math.sin(time * 2.0)
            targetRef.current.position.z = spotLightRef.current.position.z + Math.cos(time * 2.0)
            target2Ref.current.position.x =
                spotLight2Ref.current.position.x + Math.sin((time - Math.PI / 2) * 2.0)
            target2Ref.current.position.z =
                spotLight2Ref.current.position.z + Math.cos((time - Math.PI / 2) * 2.0)
        }
    })

    useEffect(() => {
        if (!init) {
            setActive(false)
        }
    }, [init, setActive, setInit])

    useEffect(() => {
        if (!init && !active) {
            setInit(true)

            // setTimeout(() => {
            //     setInit(true)
            // }, 10000)
        }
    }, [init, active, setInit])

    useEffect(() => {
        if (sirenActive) {
            spotLightRef.current.target = targetRef.current
            spotLight2Ref.current.target = target2Ref.current
            setTimeout(() => {
                setActive(true)
                setSirenActive(false)
            }, 3000)
        }
    }, [sirenActive, setSirenActive, setActive])

    const inActiveMaps = useLoader(TextureLoader, [
        "baked_floor.jpg",
        "baked_stuff.jpg",
        "baked_infinity.jpg",
        "baked_walls.jpg",
        "baked_gate.jpg",
        "baked_ramp.jpg",
        "baked_grating_ramp.jpg",
        "baked_grating_ramp_alpha.png",
        "baked_curb.jpg",
    ])

    const activeMaps = useLoader(TextureLoader, [
        "baked_floor_active.jpg",
        "baked_stuff_active.jpg",
        "baked_infinity_active.jpg",
        "baked_walls_active.jpg",
        "baked_gate_active.jpg",
        "baked_ramp_active.jpg",
        "baked_grating_ramp_active.jpg",
        "baked_grating_ramp_alpha.png",
        "baked_curb_active.jpg",
    ])

    const [
        floorMap,
        stuffMap,
        infinityMap,
        wallsMap,
        gateMap,
        rampMap,
        gratingMap,
        gratingMapAlpha,
        curbMap,
    ] = active ? activeMaps : inActiveMaps

    floorMap.flipY = false
    floorMap.encoding = sRGBEncoding

    stuffMap.flipY = false
    stuffMap.encoding = sRGBEncoding

    wallsMap.flipY = false
    wallsMap.encoding = sRGBEncoding

    infinityMap.flipY = false
    infinityMap.encoding = sRGBEncoding

    rampMap.flipY = false
    rampMap.encoding = sRGBEncoding

    gateMap.flipY = false
    gateMap.encoding = sRGBEncoding

    gratingMap.flipY = false
    gratingMap.encoding = sRGBEncoding

    gratingMapAlpha.flipY = false
    gratingMapAlpha.encoding = sRGBEncoding

    curbMap.flipY = false
    curbMap.encoding = sRGBEncoding

    // useHelper(spotLightRef, SpotLightHelper, "cyan")
    // useHelper(spotLight2Ref, SpotLightHelper, "red")

    const sirenPosition = [-5.4, 3.5, 8.2]
    const sirenColor = "#fc0"
    const sirenIntensity = 10

    return (
        <group ref={group} {...props} dispose={null}>
            {!init && (
                <mesh scale={100} position={[30, 10, 13]}>
                    <planeGeometry />
                    <meshBasicMaterial color="black" />
                </mesh>
            )}
            {sirenActive && (
                <>
                    <mesh ref={targetRef} position={[10, 3.5, 10]}></mesh>
                    <mesh ref={target2Ref} position={[10, 3.5, 10]}></mesh>=
                    <spotLight
                        color={sirenColor}
                        intensity={sirenIntensity}
                        ref={spotLightRef}
                        position={sirenPosition}
                        distance={10}
                        penumbra={0.2}
                        angle={Math.PI / 2.5}
                        castShadow
                    />
                    <spotLight
                        color={sirenColor}
                        intensity={sirenIntensity}
                        ref={spotLight2Ref}
                        position={sirenPosition}
                        distance={10}
                        penumbra={0.2}
                        angle={Math.PI / 2.5}
                        castShadow
                    />
                </>
            )}

            <ambientLight color="#fff" intensity={1} ref={ambientLightRef} />
            <mesh
                geometry={nodes.infinity.geometry}
                position={[3.11, -0.19, 8.54]}
                scale={[53.3, 53.3, 53.3]}
                receiveShadow
            >
                <meshStandardMaterial map={infinityMap} />
            </mesh>
            <animated.mesh
                geometry={nodes.portal.geometry}
                position={[0, 3.24, -0.03]}
                scale={springs.scale}
                visible={springs.visible}
            >
                <gateShaderMaterial ref={gateShaderRef} />
            </animated.mesh>
            <mesh geometry={nodes.curb.geometry} position={[0, 0, 1.82]}>
                <meshStandardMaterial map={wallsMap} />
            </mesh>
            <mesh geometry={nodes.walls.geometry} position={[0.36, 0, 2.46]} castShadow>
                <meshStandardMaterial map={wallsMap} />
            </mesh>
            <mesh geometry={nodes.floor.geometry} position={[0, 0, 1.82]}>
                <meshStandardMaterial map={floorMap} />
            </mesh>
            <mesh geometry={nodes.curb_ramp.geometry} position={[0, 0, 1.82]}>
                <meshStandardMaterial map={curbMap} />
            </mesh>
            <mesh geometry={nodes.stuff.geometry} position={[-5.71, 3.16, 7.03]}>
                <meshStandardMaterial map={stuffMap} />
            </mesh>
            <mesh geometry={nodes.light_box.geometry} position={[-5.71, 3.16, 7.03]}>
                <meshStandardMaterial color={"#fff"} emissive emissiveIntensity={2} />
            </mesh>
            <mesh geometry={nodes.light_keypad.geometry} position={[-5.72, 2.5, -0.34]}>
                <meshStandardMaterial color={"#0f0"} />
            </mesh>
            <mesh
                geometry={nodes.light_monitor.geometry}
                position={[3.51, 1.66, 9.01]}
                rotation={[-Math.PI / 2, 0, -1.12]}
            >
                <monitorShaderMaterial ref={monitorShaderRef} uMultiplier={active ? 0.1 : 0.01} />
            </mesh>
            <mesh
                geometry={nodes.light_probe.geometry}
                position={[-0.24, 1.76, 4.36]}
                rotation={[0.45, 0.15, -0.04]}
                scale={[1.11, 1.11, 1.11]}
            >
                <meshStandardMaterial color={"#fff"} />
            </mesh>
            <mesh
                geometry={nodes.light_probe_purple.geometry}
                position={[-0.57, 1.49, 4.31]}
                rotation={[0.22, 0, 0]}
            >
                <meshStandardMaterial color={"#fff"} />
            </mesh>
            <mesh
                geometry={nodes.light_red_button.geometry}
                position={[0, 1.19, 10.24]}
                rotation={[Math.PI, -1.56, Math.PI]}
                scale={[1.41, 1.41, 1.41]}
                onPointerDown={() => {
                    if (active) {
                        setActive(false)
                    } else {
                        !sirenActive && setSirenActive((s) => !s)
                    }
                }}
            >
                <meshStandardMaterial color={"#f00"} />
            </mesh>
            <mesh
                ref={lightStrobeRef}
                geometry={nodes.light_strobe.geometry}
                position={[-5.63, 3.39, 8.09]}
                scale={[0.86, 0.86, 0.86]}
            >
                <meshPhysicalMaterial
                    color={sirenActive ? "#fc0" : "#850"}
                    transmission={0.4}
                    transparent
                />
            </mesh>
            <mesh geometry={nodes.stargate.geometry} position={[3.98, 0, 0]}>
                <meshStandardMaterial map={gateMap} />
            </mesh>
            <mesh geometry={nodes.ramp.geometry} position={[0, 1.48, -1.52]}>
                <meshStandardMaterial map={rampMap} />
            </mesh>
            <mesh geometry={nodes.grating_platform.geometry}>
                <meshStandardMaterial
                    map={gratingMap}
                    alphaMap={gratingMapAlpha}
                    transparent={true}
                />
            </mesh>
            <mesh geometry={nodes.grating_ramp.geometry} position={[0, 1.48, -1.52]}>
                <meshStandardMaterial
                    map={gratingMap}
                    alphaMap={gratingMapAlpha}
                    transparent={true}
                />
            </mesh>
            <mesh
                geometry={nodes.ramp_lights.geometry}
                position={[1.08, 1.71, 2.13]}
                rotation={[0.22, 0, 0]}
                scale={[0.77, 1.06, 0.77]}
            >
                <meshStandardMaterial color={"#fff"} />
            </mesh>
            <Dust active={active} />
        </group>
    )
}

useGLTF.preload("/stargate.glb")
